import {Action} from '@ngrx/store';

export const SET_APP_VERSION = '[APPCONFIG] SET APP VRESION';

export class SetAppVersion implements Action {
    readonly type = SET_APP_VERSION;
    constructor(public payload?: string) { }
}

export type All = SetAppVersion;



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/reducers/appconfig.actions.ts